<script lang="ts">
    import { isDarkTheme } from "../../../store";
    import CalculatorBranding from "./CalculatorBranding.svelte";
</script>

<article
    class="calculator container-xsmall border-solid-2px border-pico-color"
    class:calculator-glow={$isDarkTheme}
>
    <slot />
    <CalculatorBranding />
</article>
